import React from 'react'
import StickerEmbedModalContainer from 'shared/containers/sticker-embed-modal'
import Channel from '../containers/channel'

const App = ({ query, total, gridType, isOwner, contextId, id, groupId }) => (
    <>
        <StickerEmbedModalContainer channelId={parseInt(id)} />
        <Channel
            query={query}
            total={total}
            channelId={parseInt(id)}
            channelType={contextId}
            gridType={gridType}
            isOwner={isOwner}
            groupId={groupId}
        />
    </>
)

export default App
